// extracted by mini-css-extract-plugin
export default {"pill":"Pill_pill__4iFMA","neutral":"Pill_neutral__VXyVX","amber":"Pill_amber__Lhaye","indigo":"Pill_indigo__DA8rL","success":"Pill_success__yhzQY","glass":"Pill_glass__LitLb"};